import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["inactiveSection", "activeColumn", "inactiveColumn"]
  static values = {
    inputId: String
  }

  connect() {
    this.inactiveSectionTargets.forEach(sectionEl => {
      this.updateEmptyMessage(sectionEl)
    })
  }

  enableColumn(e) {
    // enable the column

    const columnId = e.currentTarget.dataset.columnId
    const activeColumnEl = this.activeColumnTargets.find(el => el.dataset.reportColumnSelectorColumnId === columnId)
    const inactiveColumnEl = this.inactiveColumnTargets.find(el => el.dataset.reportColumnSelectorColumnId === columnId)
    if (!activeColumnEl || !inactiveColumnEl) return

    const inputEl = activeColumnEl.querySelector(`input#${this.inputIdValue}`)
    inputEl.disabled = false
    activeColumnEl.parentNode.append(activeColumnEl)
    activeColumnEl.classList.remove("hidden")
    inactiveColumnEl.classList.add("hidden")

    // show empty message if all columns in the section are enabled

    const sectionEl = this.inactiveSectionTargets.find(el => el.dataset.reportColumnSelectorSectionId === inactiveColumnEl.dataset.reportColumnSelectorSectionId)
    this.updateEmptyMessage(sectionEl)
  }

  disableColumn(e) {
    // disable the column

    const columnId = e.currentTarget.dataset.columnId
    const activeColumnEl = this.activeColumnTargets.find(el => el.dataset.reportColumnSelectorColumnId === columnId)
    const inactiveColumnEl = this.inactiveColumnTargets.find(el => el.dataset.reportColumnSelectorColumnId === columnId)
    if (!activeColumnEl || !inactiveColumnEl) return

    const inputEl = activeColumnEl.querySelector(`input#${this.inputIdValue}`)
    inputEl.disabled = true
    activeColumnEl.classList.add("hidden")
    activeColumnEl.parentNode.append(activeColumnEl)
    inactiveColumnEl.classList.remove("hidden")

    // hide empty message if any columns in the section are disabled

    const sectionEl = this.inactiveSectionTargets.find(el => el.dataset.reportColumnSelectorSectionId === inactiveColumnEl.dataset.reportColumnSelectorSectionId)
    this.updateEmptyMessage(sectionEl)
  }

  updateEmptyMessage(sectionEl) {
    const hasInactiveColumn = this.inactiveColumnTargets.some(el => {
      if (el.dataset.reportColumnSelectorSectionId !== sectionEl.dataset.reportColumnSelectorSectionId) return false
      return !el.classList.contains("hidden")
    })

    const sectionOptions = sectionEl.querySelector("[data-report-column-selector-empty-message]")
    if (!sectionOptions) return

    if (!hasInactiveColumn) {
      sectionOptions.classList.remove("hidden")
    } else {
      sectionOptions.classList.add("hidden")
    }
  }
}
